module.exports = {
      id: "logout-mobile-usage",
      viewBox: "0 0 20.886 28.808",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#logout-mobile",
      toString: function () {
        return this.url;
      }
    }